import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import TrailCard from './TrailCard';

export default class TrailsListCards extends Component {
  constructor() {
    super();
    this.state = {};

    this.redirectNewTrail = this.redirectNewTrail.bind(this);
  }

  componentDidMount() {
    const element = document.getElementById('trails-scroll-trigger');

    if (!element) return;

    const observer = new IntersectionObserver((entries) => {
      const isIntersecting = entries.some((entry) => entry.isIntersecting);
      if (isIntersecting) this.props.onScroll();
    });
    observer.observe(element);
  }

  redirectNewTrail() {
    // this.props.redirectNewTrail();
    browserHistory.push('/trail/create');
  }

  render() {
    const { cards, hasMore } = this.props;

    return (
      <div
        className="row-card-trails-list"
        id="scrollableTrails"
        style={{
          overflowX: 'hidden',
          overflowY: 'auto',
          maxHeight: '69vh',
          // boxShadow: '0px 15px 10px -15px rgba(0, 0, 0, 0.3)',
          display: 'flex',
          gap: '16px',
          flexWrap: 'wrap',
          padding: '0 15px'
        }}
        // onClick={this.redirectNewTrail}
      >
        {Array.isArray(cards) &&
          cards.map((trail) => (
            <TrailCard
              id={trail.id}
              key={trail.id}
              trail={trail}
              changeAvailableTrail={this.props.changeAvailableTrail}
              getCurrentTrail={this.props.getCurrentTrail}
              available={trail.available}
              deleteTrail={this.props.deleteTrail}
            />
          ))}

        <div
          id="trails-scroll-trigger"
          style={{
            margin: '1rem auto',
            fontSize: '12px',
            textAlign: 'center',
            display: hasMore ? 'block' : 'none',
            width: '100%'
          }}
        ></div>
      </div>
    );
  }
}
